import { UTILS } from '../actions/utils';

export const InitialState = {
  deviceType: null,
  windowWidth: null,
  pageBreakpoint: null
};

// REDUCERS
export default function (state = InitialState, action) {
  switch (action.type) {
    case UTILS.SET_DEVICE_TYPE:
      return {
        ...state,
        deviceType: action.deviceType
      };
    case UTILS.SET_WINDOW_WIDTH:
      return {
        ...state,
        windowWidth: action.windowWidth
      };
    case UTILS.SET_PAGE_BREAKPOINT:
      return {
        ...state,
        pageBreakpoint: action.pageBreakpoint
      };
    default:
      return state;
  }
}
